<template>
  <div class="menu-content">
    <div v-for="(item,index) in navMenus" :key="index">
      <el-menu-item
        :index="item.path?item.path+'':item.id+''"
        :key="item.id"
        v-if="!item.list||item.list.length===0"
        :class="path==item.path?'active-menu':'unactive-menu'"
      >
        <span slot="title">{{item.text}}</span>
      </el-menu-item>
      <el-submenu :index="item.id+''" :key="item.id" v-else>
        <template slot="title">
          <i class="el-icon-notebook-2"></i>
          {{item.text}}
        </template>
        <NavMenu :navMenus="item.list"></NavMenu>
      </el-submenu>
    </div>
  </div>
</template>
<script>
export default {
  props: ["navMenus"],
  name: "NavMenu",
  data() {
    return {};
  },
  computed: {
    path() {
      if (this.$route.path.includes("iframe")) {
        return unescape(this.$route.fullPath);
      }
      if (this.$route.meta.hidden) {
        return this.$route.matched[1].path;
      }
      return this.$route.path + "";
    }
  },
  methods: {}
};
</script>
<style lang='less' scoped>
.menu-content {
  img {
    width: 20px;
    height: 20px;
  }
}
</style>
<style lang='less'>
.menu-content {
}
</style>